import { CssBaseline } from '@mui/material';
import { BrowserRouter } from 'react-router-dom';
import AppContextProvider from './@crema/context/AppContextProvider';
import InfoViewContextProvider from './@crema/context/AppContextProvider/InfoViewContextProvider';
import AppLocaleProvider from './@crema/context/AppLocaleProvider';
import AppStyleProvider from './@crema/context/AppStyleProvider';
import AppThemeProvider from './@crema/context/AppThemeProvider';
import AppAuthProvider from './@crema/core/AppAuthProvider';
import { ConfirmProvider } from './@lbs/context/ConfirmationContext';
import { HierarchyModeProvider } from './@lbs/context/HierarchyModeContext';
import MainAppLayout from './@lbs/layout/MainLayout';

function App() {
  return (
    <AppAuthProvider>
      <HierarchyModeProvider>
        <AppContextProvider>
          <AppThemeProvider>
            <AppStyleProvider>
              <AppLocaleProvider>
                <BrowserRouter>
                  <ConfirmProvider>
                    <InfoViewContextProvider>
                      <CssBaseline />
                      <MainAppLayout />
                    </InfoViewContextProvider>
                  </ConfirmProvider>
                </BrowserRouter>
              </AppLocaleProvider>
            </AppStyleProvider>
          </AppThemeProvider>
        </AppContextProvider>
      </HierarchyModeProvider>
    </AppAuthProvider>
  );
}

export default App;
